"use client";

import styles from "./productsTabsSectionV2.module.scss";
import { useTranslation } from "react-i18next";
import { Tabs, Tab } from "@nextui-org/react";
import ProductsTabsContentV2 from "@/components/productsTabsContentV2/productsTabsContentV2";
import { useEffect, useState, useRef } from "react";
import CustomSpinner from "../spinner/spinner";
import ToggleSwitchV2 from "@/components/toggelSwictherV2/toggelSwictherV2";
import { Products } from "@/lib/products";
import { svgImages } from "@/lib/svgImages";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import TitleWithDescriptionV2 from "../titleWithDescriptionV2/titleWithDescriptionV2";
import ProductsSwiper from "../productsSwiper/productsSwiper";

gsap.registerPlugin(ScrollTrigger);

const ProductsTabsSectionV2 = () => {
  const { t } = useTranslation();
  const [isDynamic, setIsDynamic] = useState(false);
  const [allList, setAllList] = useState([]);
  const [staticList, setStaticList] = useState([]);
  const [loading, setLoading] = useState(true);
  const toggleRef = useRef(null);
  const tabsRef = useRef(null);
  const contentRef = useRef(null);
  var staticListArr = [];

  useEffect(() => {
    for (let index = 0; index < Products.productsTabsSection.length; index++) {
      const element = Products.productsTabsSection[index];
      if (!element.isDynamic) {
        staticListArr.push(element);
        setStaticList(staticListArr);
      }
    }
  }, []);

  useEffect(() => {
    (async () => {
      var allListArr = [];

      const data = await fetch(
        "https://cms.qrhub.io/wp-json/wp/v2/products?per_page=100",
        { cache: "force-cache" }
      ).then((res) => res.json());

      if (data != undefined) {
        for (let index = 0; index < data.length; index++) {
          const element = data[index];

          if (element?.acf.isdynamic == true) {
            allListArr.push(element);
            setAllList(allListArr);
          }
        }
        ScrollTrigger.refresh();
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (!loading) {
      // Create ScrollTrigger instances
      const toggleTrigger = ScrollTrigger.create({
        trigger: toggleRef.current,
        start: "top bottom-=100",
        once: true,
        onEnter: () => {
          gsap.to(toggleRef.current, {
            opacity: 1,
            duration: 0.6,
          });
        },
      });

      const tabs = tabsRef.current?.querySelectorAll(
        `.${styles["productsTab"]}`
      );
      const tabsTrigger = ScrollTrigger.create({
        trigger: tabsRef.current,
        start: "top bottom-=100",
        once: true,
        onEnter: () => {
          tabs?.forEach((tab, index) => {
            gsap.to(tab, {
              opacity: 1,
              y: 0,
              duration: 0.2,
              delay: index * 0.1,
            });
          });
        },
      });
      if (contentRef.current) {
        const contentTrigger = ScrollTrigger.create({
          trigger: contentRef.current,
          start: "top bottom-=100",
          once: true,
          onEnter: () => {
            gsap.to(contentRef.current, {
              opacity: 1,
              y: 0,
              duration: 0.3,
            });
          },
        });
      }
      // Set initial states
      gsap.set(toggleRef.current, { opacity: 0.5 });
      gsap.set(tabs, { opacity: 0, y: 10 });
      if (contentRef.current) {
        gsap.set(contentRef.current, { opacity: 0, y: 10 });
      }

      // Cleanup function
      // return () => {
      //   toggleTrigger.kill();
      //   tabsTrigger.kill();
      //   contentTrigger.kill();
      // };
    }
  }, [loading]);

  return (
    <>
      {loading ? (
        <>
          <CustomSpinner />
        </>
      ) : (
        <>
          <div className={`${styles["productsTabsSectionV2"]}`}>
            <div className="custom-container">
              <div className="inner">
                <TitleWithDescriptionV2
                  title={t("productsSection.title")}
                  description={t("productsSection.description")}
                />
                <div className={`${styles["productsTabsSectionDesktop"]}`}>
                  <div ref={toggleRef}>
                    <ToggleSwitchV2
                      isChecked={isDynamic}
                      setIsChecked={setIsDynamic}
                      firstVal={`Static`}
                      firstIcon={
                        <span
                          dangerouslySetInnerHTML={{
                            __html: svgImages.arrowRight,
                          }}
                        />
                      }
                      secondVal={`Dynamic`}
                      secondIcon={
                        <span
                          dangerouslySetInnerHTML={{
                            __html: svgImages.arrowRight,
                          }}
                        />
                      }
                      pricingPage={false}
                    />
                  </div>
                  {!isDynamic ? (
                    <div ref={tabsRef}>
                      <Tabs
                        aria-label="Our Products"
                        items={allList.sort((a, b) => (a.id < b.id ? -1 : 1))}
                        className={`${styles["productsTabs"]} d-flex-md d-none-xs`}
                      >
                        {(item) => (
                          <Tab
                            className={`${styles["productsTab"]}`}
                            key={item.slug}
                            title={
                              <>
                                <div className={`${styles["tabButton"]}`}>
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        svgImages[item.slug.replace(/-/g, "_")],
                                    }}
                                  />
                                  <span className="font-size-15">
                                    {item.acf.hero_title}
                                  </span>
                                </div>
                              </>
                            }
                          >
                            <div ref={contentRef}>
                              <ProductsTabsContentV2
                                title={item.acf.hero_title}
                                description={item.content.rendered}
                                url={
                                  item.acf.isdynamic
                                    ? `/en/products/${item.slug}`
                                    : ""
                                }
                                image={`/images/products/${item.slug}.webp`}
                              />
                            </div>
                          </Tab>
                        )}
                      </Tabs>
                    </div>
                  ) : (
                    <div ref={tabsRef}>
                      <Tabs
                        aria-label="Our Products"
                        items={staticList}
                        className={`${styles["productsTabs"]} ${styles["productsTabsStatic"]} d-flex-md d-none-xs`}
                      >
                        {(item) => (
                          <Tab
                            className={`${styles["productsTab"]} ${styles["staticButton"]}`}
                            key={t(item.title)}
                            title={
                              <div className={`${styles["tabButton"]}`}>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      svgImages[
                                        `qr_${t(item.title)
                                          .toLowerCase()
                                          .replace(/[\s-]/g, "_")}`
                                      ],
                                  }}
                                />
                                <span>{t(item.title)}</span>
                              </div>
                            }
                          >
                            <div ref={contentRef}>
                              <ProductsTabsContentV2
                                title={t(item.title)}
                                description={t(item.description)}
                                url={`/en/static-products`}
                                image={item.image}
                                isStatic={true}
                              />
                            </div>
                          </Tab>
                        )}
                      </Tabs>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className={`${styles["productsCardsMobile"]} d-none-md d-flex-xs`}
            >
              {!isDynamic ? (
                <ProductsSwiper data={allList} isDynamic={true} />
              ) : (
                <ProductsSwiper data={staticList} isDynamic={false} />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ProductsTabsSectionV2;
